export class ComplianceFlag {
  async add(params, resolve) {
    const response = await fetch("/admin/compliance_flags", {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ compliance_flag: params, resolve: !!resolve }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async search(params) {
    const response = await fetch("/admin/compliance_flags/search", {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(params),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async destroy(params) {
    const response = await fetch(`/admin/compliance_flags/${params.id}`, {
      method: "DELETE",
      credentials: "include",
      body: JSON.stringify({ compliance_flag: params }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async resolve(params, accountNote) {
    const response = await fetch(
      `/admin/compliance_flags/${params.id}/resolve`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          compliance_flag: params,
          account_note: accountNote
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            .content
        }
      }
    )

    return await response.json()
  }

  async resolveAll(params, accountNote) {
    const response = await fetch(
      `/admin/compliance_flags/${params.id}/resolve_all_same_account`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          compliance_flag: params,
          account_note: accountNote
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            .content
        }
      }
    )

    return await response.json()
  }

  async watch(params, accountNote) {
    const response = await fetch(`/admin/compliance_flags/${params.id}/watch`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        compliance_flag: params,
        account_note: accountNote
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async falsePositive(params) {
    const response = await fetch(
      `/admin/compliance_flags/${params.id}/false_positive`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          compliance_flag: params
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            .content
        }
      }
    )

    return await response.json()
  }

  async unFalsePositive(params) {
    const response = await fetch(
      `/admin/compliance_flags/${params.id}/un_false_positive`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          compliance_flag: params
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            .content
        }
      }
    )

    return await response.json()
  }
}
